/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/pipeline_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { PipelineServiceCreateStageTaskBody } from '../models'
// @ts-ignore
import { PipelineServiceSetStageRequiredClientFieldsBody } from '../models'
// @ts-ignore
import { PipelineServiceSetStageRequiredDocumentsBody } from '../models'
// @ts-ignore
import { PipelineServiceUpdateDocumentTypeBody } from '../models'
// @ts-ignore
import { PipelineServiceUpdatePipelineStageBody } from '../models'
// @ts-ignore
import { PipelineServiceUpdateStageTaskBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1CreateDocumentTypeRequest } from '../models'
// @ts-ignore
import { V1CreatePipelineStageRequest } from '../models'
// @ts-ignore
import { V1DocumentTypeResponse } from '../models'
// @ts-ignore
import { V1GetPipelineConstructorResponse } from '../models'
// @ts-ignore
import { V1ListDocumentTypesResponse } from '../models'
// @ts-ignore
import { V1ListPipelineStagesResponse } from '../models'
// @ts-ignore
import { V1ListStageTasksResponse } from '../models'
// @ts-ignore
import { V1PipelineStageResponse } from '../models'
// @ts-ignore
import { V1ReorderPipelineStagesRequest } from '../models'
// @ts-ignore
import { V1SetStageRequiredClientFieldsResponse } from '../models'
// @ts-ignore
import { V1SetStageRequiredDocumentsResponse } from '../models'
// @ts-ignore
import { V1StageTaskTemplateResponse } from '../models'
/**
 * PipelineServiceApi - axios parameter creator
 * @export
 */
export const PipelineServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Internal note: requires pipeline:create.
     * @summary Describes a new kind of document. The name is given once, in whatever language the author writes in, and translated into the others automatically.
     * @param {V1CreateDocumentTypeRequest} body A new kind of document.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceCreateDocumentType: async (
      body: V1CreateDocumentTypeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceCreateDocumentType', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/document-types`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:create.
     * @summary Adds a stage. The name is given once, in whatever language the author writes in, and translated into the others automatically.
     * @param {V1CreatePipelineStageRequest} body A new stage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceCreatePipelineStage: async (
      body: V1CreatePipelineStageRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceCreatePipelineStage', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stages`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Adds a task template to a stage. The title is translated automatically.
     * @param {string} stageId
     * @param {PipelineServiceCreateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceCreateStageTask: async (
      stageId: string,
      body: PipelineServiceCreateStageTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'stageId' is not null or undefined
      assertParamExists('pipelineServiceCreateStageTask', 'stageId', stageId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceCreateStageTask', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stages/{stageId}/tasks`.replace(
        `{${'stageId'}}`,
        encodeURIComponent(String(stageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:delete.
     * @summary Removes a document type. Stages stop asking for it; files already attached to deals stay where they are.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceDeleteDocumentType: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pipelineServiceDeleteDocumentType', 'id', id)
      const localVarPath = `/api/v1/deals/pipeline/document-types/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:delete.
     * @summary Removes a stage. A stage that still holds active deals can only be removed by naming the stage those deals should move to, and system stages cannot be removed at all.
     * @param {string} id
     * @param {string} [reassignToStageId] Stage to move the deals of the removed stage to. Without it, removing a stage that still holds active deals is refused.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceDeletePipelineStage: async (
      id: string,
      reassignToStageId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pipelineServiceDeletePipelineStage', 'id', id)
      const localVarPath = `/api/v1/deals/pipeline/stages/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (reassignToStageId !== undefined) {
        localVarQueryParameter['reassignToStageId'] = reassignToStageId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Removes a task template. Tasks already created from it stay on their deals.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceDeleteStageTask: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pipelineServiceDeleteStageTask', 'id', id)
      const localVarPath = `/api/v1/deals/pipeline/stage-tasks/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Returns the whole funnel with every translation of every name, for the editor screen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceGetPipelineConstructor: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/pipeline/constructor`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:read.
     * @summary Lists the document types, with names in the requested language. The deal card needs them to label the documents it asks for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceListDocumentTypes: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/pipeline/document-types`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:read.
     * @summary Lists the stages of the funnel, in order, with names in the requested language. This is what the kanban board is built from.
     * @param {boolean} [includeTaskTemplates] Also return the task templates of each stage. The kanban board does not need them; the editor does.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceListPipelineStages: async (
      includeTaskTemplates?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/pipeline/stages`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeTaskTemplates !== undefined) {
        localVarQueryParameter['includeTaskTemplates'] = includeTaskTemplates
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:read.
     * @summary Lists the task templates of one stage, with titles in the requested language.
     * @param {string} stageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceListStageTasks: async (
      stageId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'stageId' is not null or undefined
      assertParamExists('pipelineServiceListStageTasks', 'stageId', stageId)
      const localVarPath = `/api/v1/deals/pipeline/stages/{stageId}/tasks`.replace(
        `{${'stageId'}}`,
        encodeURIComponent(String(stageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Reorders the funnel. The whole list of stage identifiers is sent in the new order.
     * @param {V1ReorderPipelineStagesRequest} body The whole list of stage identifiers, in the order they should appear.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceReorderPipelineStages: async (
      body: V1ReorderPipelineStagesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceReorderPipelineStages', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stages:reorder`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * The keys come from the client service, which publishes the fields that can be asked for. A key it no longer publishes stops being required rather than holding a deal back forever.  Internal note: requires pipeline:update.
     * @summary Sets which client card fields a stage requires. Like the documents above, the whole list is sent at once and replaces the previous one; an empty list means the stage asks for nothing.
     * @param {string} stageId
     * @param {PipelineServiceSetStageRequiredClientFieldsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceSetStageRequiredClientFields: async (
      stageId: string,
      body: PipelineServiceSetStageRequiredClientFieldsBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'stageId' is not null or undefined
      assertParamExists('pipelineServiceSetStageRequiredClientFields', 'stageId', stageId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceSetStageRequiredClientFields', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stages/{stageId}/required-client-fields`.replace(
        `{${'stageId'}}`,
        encodeURIComponent(String(stageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Sets which documents a stage requires. The whole list is sent at once and replaces the previous one; an empty list means the stage asks for nothing.
     * @param {string} stageId
     * @param {PipelineServiceSetStageRequiredDocumentsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceSetStageRequiredDocuments: async (
      stageId: string,
      body: PipelineServiceSetStageRequiredDocumentsBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'stageId' is not null or undefined
      assertParamExists('pipelineServiceSetStageRequiredDocuments', 'stageId', stageId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceSetStageRequiredDocuments', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stages/{stageId}/required-documents`.replace(
        `{${'stageId'}}`,
        encodeURIComponent(String(stageId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Changes a document type. The lists of formats and of fields are replaced whole: what the editor sends is what the type ends up with.
     * @param {string} id
     * @param {PipelineServiceUpdateDocumentTypeBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceUpdateDocumentType: async (
      id: string,
      body: PipelineServiceUpdateDocumentTypeBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pipelineServiceUpdateDocumentType', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceUpdateDocumentType', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/document-types/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Changes a stage: its name, colour, kind or work-in-progress limit. A new name overrides the author\'s language and is translated into the missing ones.
     * @param {string} id
     * @param {PipelineServiceUpdatePipelineStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceUpdatePipelineStage: async (
      id: string,
      body: PipelineServiceUpdatePipelineStageBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pipelineServiceUpdatePipelineStage', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceUpdatePipelineStage', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stages/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Changes a task template. Tasks already created from it are left alone.
     * @param {string} id
     * @param {PipelineServiceUpdateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceUpdateStageTask: async (
      id: string,
      body: PipelineServiceUpdateStageTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('pipelineServiceUpdateStageTask', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('pipelineServiceUpdateStageTask', 'body', body)
      const localVarPath = `/api/v1/deals/pipeline/stage-tasks/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PipelineServiceApi - functional programming interface
 * @export
 */
export const PipelineServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PipelineServiceApiAxiosParamCreator(configuration)
  return {
    /**
     * Internal note: requires pipeline:create.
     * @summary Describes a new kind of document. The name is given once, in whatever language the author writes in, and translated into the others automatically.
     * @param {V1CreateDocumentTypeRequest} body A new kind of document.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceCreateDocumentType(
      body: V1CreateDocumentTypeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DocumentTypeResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceCreateDocumentType(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceCreateDocumentType']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:create.
     * @summary Adds a stage. The name is given once, in whatever language the author writes in, and translated into the others automatically.
     * @param {V1CreatePipelineStageRequest} body A new stage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceCreatePipelineStage(
      body: V1CreatePipelineStageRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PipelineStageResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceCreatePipelineStage(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceCreatePipelineStage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Adds a task template to a stage. The title is translated automatically.
     * @param {string} stageId
     * @param {PipelineServiceCreateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceCreateStageTask(
      stageId: string,
      body: PipelineServiceCreateStageTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1StageTaskTemplateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceCreateStageTask(
        stageId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceCreateStageTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:delete.
     * @summary Removes a document type. Stages stop asking for it; files already attached to deals stay where they are.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceDeleteDocumentType(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceDeleteDocumentType(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceDeleteDocumentType']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:delete.
     * @summary Removes a stage. A stage that still holds active deals can only be removed by naming the stage those deals should move to, and system stages cannot be removed at all.
     * @param {string} id
     * @param {string} [reassignToStageId] Stage to move the deals of the removed stage to. Without it, removing a stage that still holds active deals is refused.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceDeletePipelineStage(
      id: string,
      reassignToStageId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceDeletePipelineStage(
        id,
        reassignToStageId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceDeletePipelineStage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Removes a task template. Tasks already created from it stay on their deals.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceDeleteStageTask(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceDeleteStageTask(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceDeleteStageTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Returns the whole funnel with every translation of every name, for the editor screen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceGetPipelineConstructor(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetPipelineConstructorResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.pipelineServiceGetPipelineConstructor(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceGetPipelineConstructor']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:read.
     * @summary Lists the document types, with names in the requested language. The deal card needs them to label the documents it asks for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceListDocumentTypes(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDocumentTypesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.pipelineServiceListDocumentTypes(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceListDocumentTypes']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:read.
     * @summary Lists the stages of the funnel, in order, with names in the requested language. This is what the kanban board is built from.
     * @param {boolean} [includeTaskTemplates] Also return the task templates of each stage. The kanban board does not need them; the editor does.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceListPipelineStages(
      includeTaskTemplates?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListPipelineStagesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceListPipelineStages(
        includeTaskTemplates,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceListPipelineStages']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:read.
     * @summary Lists the task templates of one stage, with titles in the requested language.
     * @param {string} stageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceListStageTasks(
      stageId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListStageTasksResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceListStageTasks(
        stageId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceListStageTasks']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Reorders the funnel. The whole list of stage identifiers is sent in the new order.
     * @param {V1ReorderPipelineStagesRequest} body The whole list of stage identifiers, in the order they should appear.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceReorderPipelineStages(
      body: V1ReorderPipelineStagesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListPipelineStagesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.pipelineServiceReorderPipelineStages(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceReorderPipelineStages']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * The keys come from the client service, which publishes the fields that can be asked for. A key it no longer publishes stops being required rather than holding a deal back forever.  Internal note: requires pipeline:update.
     * @summary Sets which client card fields a stage requires. Like the documents above, the whole list is sent at once and replaces the previous one; an empty list means the stage asks for nothing.
     * @param {string} stageId
     * @param {PipelineServiceSetStageRequiredClientFieldsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceSetStageRequiredClientFields(
      stageId: string,
      body: PipelineServiceSetStageRequiredClientFieldsBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<V1SetStageRequiredClientFieldsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.pipelineServiceSetStageRequiredClientFields(
          stageId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceSetStageRequiredClientFields']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Sets which documents a stage requires. The whole list is sent at once and replaces the previous one; an empty list means the stage asks for nothing.
     * @param {string} stageId
     * @param {PipelineServiceSetStageRequiredDocumentsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceSetStageRequiredDocuments(
      stageId: string,
      body: PipelineServiceSetStageRequiredDocumentsBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<V1SetStageRequiredDocumentsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.pipelineServiceSetStageRequiredDocuments(
          stageId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceSetStageRequiredDocuments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Changes a document type. The lists of formats and of fields are replaced whole: what the editor sends is what the type ends up with.
     * @param {string} id
     * @param {PipelineServiceUpdateDocumentTypeBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceUpdateDocumentType(
      id: string,
      body: PipelineServiceUpdateDocumentTypeBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DocumentTypeResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceUpdateDocumentType(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceUpdateDocumentType']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Changes a stage: its name, colour, kind or work-in-progress limit. A new name overrides the author\'s language and is translated into the missing ones.
     * @param {string} id
     * @param {PipelineServiceUpdatePipelineStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceUpdatePipelineStage(
      id: string,
      body: PipelineServiceUpdatePipelineStageBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PipelineStageResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceUpdatePipelineStage(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceUpdatePipelineStage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Changes a task template. Tasks already created from it are left alone.
     * @param {string} id
     * @param {PipelineServiceUpdateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async pipelineServiceUpdateStageTask(
      id: string,
      body: PipelineServiceUpdateStageTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1StageTaskTemplateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.pipelineServiceUpdateStageTask(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PipelineServiceApi.pipelineServiceUpdateStageTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PipelineServiceApi - factory interface
 * @export
 */
export const PipelineServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PipelineServiceApiFp(configuration)
  return {
    /**
     * Internal note: requires pipeline:create.
     * @summary Describes a new kind of document. The name is given once, in whatever language the author writes in, and translated into the others automatically.
     * @param {V1CreateDocumentTypeRequest} body A new kind of document.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceCreateDocumentType(
      body: V1CreateDocumentTypeRequest,
      options?: any,
    ): AxiosPromise<V1DocumentTypeResponse> {
      return localVarFp
        .pipelineServiceCreateDocumentType(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:create.
     * @summary Adds a stage. The name is given once, in whatever language the author writes in, and translated into the others automatically.
     * @param {V1CreatePipelineStageRequest} body A new stage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceCreatePipelineStage(
      body: V1CreatePipelineStageRequest,
      options?: any,
    ): AxiosPromise<V1PipelineStageResponse> {
      return localVarFp
        .pipelineServiceCreatePipelineStage(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Adds a task template to a stage. The title is translated automatically.
     * @param {string} stageId
     * @param {PipelineServiceCreateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceCreateStageTask(
      stageId: string,
      body: PipelineServiceCreateStageTaskBody,
      options?: any,
    ): AxiosPromise<V1StageTaskTemplateResponse> {
      return localVarFp
        .pipelineServiceCreateStageTask(stageId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:delete.
     * @summary Removes a document type. Stages stop asking for it; files already attached to deals stay where they are.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceDeleteDocumentType(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .pipelineServiceDeleteDocumentType(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:delete.
     * @summary Removes a stage. A stage that still holds active deals can only be removed by naming the stage those deals should move to, and system stages cannot be removed at all.
     * @param {string} id
     * @param {string} [reassignToStageId] Stage to move the deals of the removed stage to. Without it, removing a stage that still holds active deals is refused.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceDeletePipelineStage(
      id: string,
      reassignToStageId?: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .pipelineServiceDeletePipelineStage(id, reassignToStageId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Removes a task template. Tasks already created from it stay on their deals.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceDeleteStageTask(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .pipelineServiceDeleteStageTask(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Returns the whole funnel with every translation of every name, for the editor screen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceGetPipelineConstructor(
      options?: any,
    ): AxiosPromise<V1GetPipelineConstructorResponse> {
      return localVarFp
        .pipelineServiceGetPipelineConstructor(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:read.
     * @summary Lists the document types, with names in the requested language. The deal card needs them to label the documents it asks for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceListDocumentTypes(options?: any): AxiosPromise<V1ListDocumentTypesResponse> {
      return localVarFp
        .pipelineServiceListDocumentTypes(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:read.
     * @summary Lists the stages of the funnel, in order, with names in the requested language. This is what the kanban board is built from.
     * @param {boolean} [includeTaskTemplates] Also return the task templates of each stage. The kanban board does not need them; the editor does.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceListPipelineStages(
      includeTaskTemplates?: boolean,
      options?: any,
    ): AxiosPromise<V1ListPipelineStagesResponse> {
      return localVarFp
        .pipelineServiceListPipelineStages(includeTaskTemplates, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:read.
     * @summary Lists the task templates of one stage, with titles in the requested language.
     * @param {string} stageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceListStageTasks(
      stageId: string,
      options?: any,
    ): AxiosPromise<V1ListStageTasksResponse> {
      return localVarFp
        .pipelineServiceListStageTasks(stageId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Reorders the funnel. The whole list of stage identifiers is sent in the new order.
     * @param {V1ReorderPipelineStagesRequest} body The whole list of stage identifiers, in the order they should appear.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceReorderPipelineStages(
      body: V1ReorderPipelineStagesRequest,
      options?: any,
    ): AxiosPromise<V1ListPipelineStagesResponse> {
      return localVarFp
        .pipelineServiceReorderPipelineStages(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * The keys come from the client service, which publishes the fields that can be asked for. A key it no longer publishes stops being required rather than holding a deal back forever.  Internal note: requires pipeline:update.
     * @summary Sets which client card fields a stage requires. Like the documents above, the whole list is sent at once and replaces the previous one; an empty list means the stage asks for nothing.
     * @param {string} stageId
     * @param {PipelineServiceSetStageRequiredClientFieldsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceSetStageRequiredClientFields(
      stageId: string,
      body: PipelineServiceSetStageRequiredClientFieldsBody,
      options?: any,
    ): AxiosPromise<V1SetStageRequiredClientFieldsResponse> {
      return localVarFp
        .pipelineServiceSetStageRequiredClientFields(stageId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Sets which documents a stage requires. The whole list is sent at once and replaces the previous one; an empty list means the stage asks for nothing.
     * @param {string} stageId
     * @param {PipelineServiceSetStageRequiredDocumentsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceSetStageRequiredDocuments(
      stageId: string,
      body: PipelineServiceSetStageRequiredDocumentsBody,
      options?: any,
    ): AxiosPromise<V1SetStageRequiredDocumentsResponse> {
      return localVarFp
        .pipelineServiceSetStageRequiredDocuments(stageId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Changes a document type. The lists of formats and of fields are replaced whole: what the editor sends is what the type ends up with.
     * @param {string} id
     * @param {PipelineServiceUpdateDocumentTypeBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceUpdateDocumentType(
      id: string,
      body: PipelineServiceUpdateDocumentTypeBody,
      options?: any,
    ): AxiosPromise<V1DocumentTypeResponse> {
      return localVarFp
        .pipelineServiceUpdateDocumentType(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Changes a stage: its name, colour, kind or work-in-progress limit. A new name overrides the author\'s language and is translated into the missing ones.
     * @param {string} id
     * @param {PipelineServiceUpdatePipelineStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceUpdatePipelineStage(
      id: string,
      body: PipelineServiceUpdatePipelineStageBody,
      options?: any,
    ): AxiosPromise<V1PipelineStageResponse> {
      return localVarFp
        .pipelineServiceUpdatePipelineStage(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires pipeline:update.
     * @summary Changes a task template. Tasks already created from it are left alone.
     * @param {string} id
     * @param {PipelineServiceUpdateStageTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pipelineServiceUpdateStageTask(
      id: string,
      body: PipelineServiceUpdateStageTaskBody,
      options?: any,
    ): AxiosPromise<V1StageTaskTemplateResponse> {
      return localVarFp
        .pipelineServiceUpdateStageTask(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * PipelineServiceApi - object-oriented interface
 * @export
 * @class PipelineServiceApi
 * @extends {BaseAPI}
 */
export class PipelineServiceApi extends BaseAPI {
  /**
   * Internal note: requires pipeline:create.
   * @summary Describes a new kind of document. The name is given once, in whatever language the author writes in, and translated into the others automatically.
   * @param {V1CreateDocumentTypeRequest} body A new kind of document.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceCreateDocumentType(
    body: V1CreateDocumentTypeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceCreateDocumentType(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:create.
   * @summary Adds a stage. The name is given once, in whatever language the author writes in, and translated into the others automatically.
   * @param {V1CreatePipelineStageRequest} body A new stage.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceCreatePipelineStage(
    body: V1CreatePipelineStageRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceCreatePipelineStage(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:update.
   * @summary Adds a task template to a stage. The title is translated automatically.
   * @param {string} stageId
   * @param {PipelineServiceCreateStageTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceCreateStageTask(
    stageId: string,
    body: PipelineServiceCreateStageTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceCreateStageTask(stageId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:delete.
   * @summary Removes a document type. Stages stop asking for it; files already attached to deals stay where they are.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceDeleteDocumentType(id: string, options?: RawAxiosRequestConfig) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceDeleteDocumentType(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:delete.
   * @summary Removes a stage. A stage that still holds active deals can only be removed by naming the stage those deals should move to, and system stages cannot be removed at all.
   * @param {string} id
   * @param {string} [reassignToStageId] Stage to move the deals of the removed stage to. Without it, removing a stage that still holds active deals is refused.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceDeletePipelineStage(
    id: string,
    reassignToStageId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceDeletePipelineStage(id, reassignToStageId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:update.
   * @summary Removes a task template. Tasks already created from it stay on their deals.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceDeleteStageTask(id: string, options?: RawAxiosRequestConfig) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceDeleteStageTask(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:update.
   * @summary Returns the whole funnel with every translation of every name, for the editor screen.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceGetPipelineConstructor(options?: RawAxiosRequestConfig) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceGetPipelineConstructor(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:read.
   * @summary Lists the document types, with names in the requested language. The deal card needs them to label the documents it asks for.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceListDocumentTypes(options?: RawAxiosRequestConfig) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceListDocumentTypes(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:read.
   * @summary Lists the stages of the funnel, in order, with names in the requested language. This is what the kanban board is built from.
   * @param {boolean} [includeTaskTemplates] Also return the task templates of each stage. The kanban board does not need them; the editor does.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceListPipelineStages(
    includeTaskTemplates?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceListPipelineStages(includeTaskTemplates, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:read.
   * @summary Lists the task templates of one stage, with titles in the requested language.
   * @param {string} stageId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceListStageTasks(stageId: string, options?: RawAxiosRequestConfig) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceListStageTasks(stageId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:update.
   * @summary Reorders the funnel. The whole list of stage identifiers is sent in the new order.
   * @param {V1ReorderPipelineStagesRequest} body The whole list of stage identifiers, in the order they should appear.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceReorderPipelineStages(
    body: V1ReorderPipelineStagesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceReorderPipelineStages(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * The keys come from the client service, which publishes the fields that can be asked for. A key it no longer publishes stops being required rather than holding a deal back forever.  Internal note: requires pipeline:update.
   * @summary Sets which client card fields a stage requires. Like the documents above, the whole list is sent at once and replaces the previous one; an empty list means the stage asks for nothing.
   * @param {string} stageId
   * @param {PipelineServiceSetStageRequiredClientFieldsBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceSetStageRequiredClientFields(
    stageId: string,
    body: PipelineServiceSetStageRequiredClientFieldsBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceSetStageRequiredClientFields(stageId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:update.
   * @summary Sets which documents a stage requires. The whole list is sent at once and replaces the previous one; an empty list means the stage asks for nothing.
   * @param {string} stageId
   * @param {PipelineServiceSetStageRequiredDocumentsBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceSetStageRequiredDocuments(
    stageId: string,
    body: PipelineServiceSetStageRequiredDocumentsBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceSetStageRequiredDocuments(stageId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:update.
   * @summary Changes a document type. The lists of formats and of fields are replaced whole: what the editor sends is what the type ends up with.
   * @param {string} id
   * @param {PipelineServiceUpdateDocumentTypeBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceUpdateDocumentType(
    id: string,
    body: PipelineServiceUpdateDocumentTypeBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceUpdateDocumentType(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:update.
   * @summary Changes a stage: its name, colour, kind or work-in-progress limit. A new name overrides the author\'s language and is translated into the missing ones.
   * @param {string} id
   * @param {PipelineServiceUpdatePipelineStageBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceUpdatePipelineStage(
    id: string,
    body: PipelineServiceUpdatePipelineStageBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceUpdatePipelineStage(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires pipeline:update.
   * @summary Changes a task template. Tasks already created from it are left alone.
   * @param {string} id
   * @param {PipelineServiceUpdateStageTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PipelineServiceApi
   */
  public pipelineServiceUpdateStageTask(
    id: string,
    body: PipelineServiceUpdateStageTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PipelineServiceApiFp(this.configuration)
      .pipelineServiceUpdateStageTask(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
